import { LOGIN_ACCENT, MOBILE_SHELL_BACKGROUND, MOBILE_SHELL_BASE_COLOR } from '../components/auth/loginDarkTheme';
import { mobileAppGlassCard, mobileHideScrollbarSx } from '../components/layout/mobile/mobileAppTheme';
import { THEME_COLORS } from '../shared/constants/theme';
import { isMobileShellLayout } from './mobileShellLayout';

/** Fixed graph grid + glow orbs matching login / MobileAuthShell. */
export const mobileShellGraphBackdropSx = {
  pointerEvents: 'none',
  position: 'fixed',
  inset: 0,
  zIndex: 0,
  overflow: 'hidden',
  background: MOBILE_SHELL_BACKGROUND,
  backgroundColor: MOBILE_SHELL_BASE_COLOR,
  '&::before': {
    content: '""',
    position: 'absolute',
    inset: 0,
    opacity: 0.07,
    backgroundImage:
      'linear-gradient(rgba(76, 225, 182, 0.65) 1px, transparent 1px), linear-gradient(90deg, rgba(76, 225, 182, 0.65) 1px, transparent 1px)',
    backgroundSize: '48px 48px',
  },
  '&::after': {
    content: '""',
    position: 'absolute',
    top: '-12%',
    right: '-20%',
    width: 280,
    height: 280,
    borderRadius: '50%',
    filter: 'blur(60px)',
    background: `radial-gradient(circle, ${LOGIN_ACCENT}40 0%, transparent 70%)`,
  },
};

/** Outer page wrapper for mobile shell routes. */
export function getMobilePageShellSx(themeMode = 'dark', options = {}) {
  const { padding = { xs: 1.5, sm: 2 }, minHeight = 0 } = options;
  if (isMobileShellLayout()) {
    return {
      position: 'relative',
      zIndex: 1,
      width: '100%',
      p: padding,
      minHeight,
      backgroundColor: 'transparent',
      color: '#f8fafc',
      ...mobileHideScrollbarSx,
    };
  }

  const isDark = themeMode === 'dark';
  return {
    p: padding,
    backgroundColor: isDark ? THEME_COLORS.BACKGROUND_DARK : '#f2f4f7',
    minHeight: minHeight || '100vh',
    transition: 'background-color 0.3s ease',
  };
}

/** Glass Paper/Card surface on mobile shell; legacy surfaces on desktop. */
export function getMobilePaperSx(themeMode = 'dark', options = {}) {
  const { mb = 2, p = { xs: 1.5, sm: 2 } } = options;
  if (isMobileShellLayout()) {
    return {
      ...mobileAppGlassCard,
      mb,
      p,
      color: '#f8fafc',
    };
  }

  const isDark = themeMode === 'dark';
  return {
    p,
    mb,
    backgroundColor: isDark ? '#2a2a31' : '#ffffff',
    backgroundImage: isDark
      ? 'linear-gradient(rgb(104 107 118 / 16%), rgb(22 22 25 / 0%))'
      : 'none',
    border: `1px solid ${isDark ? '#333246' : '#e0e0e0'}`,
    borderRadius: 2,
    transition: 'background-color 0.3s ease, border-color 0.3s ease',
  };
}

export function getMobileCardSx(themeMode = 'dark', options = {}) {
  const base = getMobilePaperSx(themeMode, options);
  if (isMobileShellLayout()) {
    return {
      ...mobileAppGlassCard,
      ...options,
      color: '#f8fafc',
    };
  }
  return base;
}

export function getMobileTextPrimary(themeMode = 'dark') {
  return isMobileShellLayout() ? '#f8fafc' : themeMode === 'dark' ? '#ddd' : '#212121';
}

export function getMobileTextSecondary(themeMode = 'dark') {
  return isMobileShellLayout() ? 'rgba(148, 163, 184, 0.92)' : themeMode === 'dark' ? '#999' : '#757575';
}
